import { useEffect, useState } from 'react'
import SliderImages from '../../component/CustomSlider/SliderImages'
import './style.css'
import DateRangeSelector from '../Flights/Dropdown/DateSelector'
import moment from 'moment'
import RoomsGuests from '../Flights/Dropdown/RoomsGuests'
import {
  setLoadingFalse,
  setLoadingTrue
} from '../../Config/Actions/loadingActions'
import { useDispatch } from 'react-redux'
import axios from 'axios'
import SearchDropdown from '../Flights/Dropdown/SearchDropdown'
import { City } from 'country-state-city'
import EndDateSelector from '../Flights/Dropdown/endDateSelector'
const Hotels = () => {
  const [sliderImages, setSliderImages] = useState([])
  const [flightsForm, setFlightsForm] = useState([])
  const [dateRangeOpen, setDateRangeOpen] = useState(false)
  const [guestCounterOpen, setGuestCounterOpen] = useState(false)
  const [selectedFare, setSelectedFare] = useState('3 Star')
  const [tripType, setTripType] = useState('Domestic')
  const [currentIndex, setCurrentIndex] = useState(0)
  const [success, setSuccess] = useState(false)
  const [endOpen, setDateEndOpen] = useState(false)

  useEffect(() => {
    fetch('/PackageJson/Hotels/HotelsImages.json')
      .then(response => response.json())
      .then(data => {
        setSliderImages(data)
      })
      .catch(error => console.error('Error loading JSON:', error))
  }, [])
  useEffect(() => {
    fetch('/PackageJson/Hotels/HotelsForm.json')
      .then(response => response.json())
      .then(data => {
        setFlightsForm(data)
      })
      .catch(error => console.error('Error loading JSON:', error))
  }, [])
  const nextSlide = () => {
    setCurrentIndex(prevIndex =>
      prevIndex === flightsForm[0]?.displayBackground.length - 1
        ? 0
        : prevIndex + 1
    )
  }
  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide()
    }, 3000)
    return () => clearInterval(interval)
  }, [flightsForm])
  const [formData, setFormData] = useState({
    full_name: '',
    contact: '',
    email: '',
    product_type: 'hotels',
    departureDate: '',
    returnDate: '',
    rooms: 0,
    adults: 0,
    children: 0,
    city: ''
  })
  const handleChange = e => {
    const { name, value } = e.target
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }))
  }
  const totalTravelers = formData.rooms + formData.adults + formData.children
  const handleChangeTripType = event => {
    setTripType(event.target.value)
  }
  const dispatch = useDispatch()

  const handleSubmit = async e => {
    e.preventDefault()
    dispatch(setLoadingTrue())
    const FormData = {
      to: formData.email,
      subject: 'Hotels',
      fullName: formData.full_name,
      Email: formData.email,
      Contact: formData.contact,
      startDate: moment(formData.departureDate).format('DD MMM YYYY'),
      EndDate: moment(formData.returnDate).format('DD MMM YYYY'),
      Adult: formData.adults,
      Child: formData.children,
      Infant: formData.rooms,
      TypeDomestic: tripType,
      City: formData.city,
      PropertyType: selectedFare
    }

    try {
      const response = await axios.post(
        'https://arrshiyanatravels.com/api/send_email.php',
        FormData
      )
      dispatch(setLoadingFalse())
      setSuccess(true)
      setTimeout(() => setSuccess(false), 3000)
      setFormData(prevState => ({
        ...prevState,
        full_name: '',
        contact: '',
        email: '',
        product_type: 'hotels',
        adults: 0,
        children: 0,
        infants: 0,
        travelClass: '',
        departureDate: '',
        returnDate: '',
        city: ''
      }))
    } catch (error) {
      console.error('Error submitting form:', error)
    }
  }
  const handleCitySelect = selectedCity => {
    setFormData(prevState => ({
      ...prevState,
      city: selectedCity
    }))
  }
  const handleOnchangeDate = item => {
    setFormData(prevState => ({
      ...prevState,
      departureDate: item.selection.startDate
    }))
  }
  const handleOnchangeEndOpen = item => {
    setFormData(prevState => ({
      ...prevState,
      returnDate: item.selection.startDate
    }))
  }
  return (
    <div>
      <div className='hotels'>
        <div
          style={{
            height: '',
            backgroundImage: `url(${flightsForm[0]?.displayBackground[0]})`,
            backgroundPosition: 'center',
            backgroundSize: 'Cover',
            backgroundRepeat: 'no-repeat',
            padding: '0px 0px'
          }}
          className='product-container'
        >
          <div className='container'>
            <div className='product-area'>
              <p>Book Domestic and International Property</p>

              <form onSubmit={handleSubmit}>
                <div className='radio-group'>
                  <label
                    className={`radio-label ${
                      tripType === 'Domestic' ? 'selected' : ''
                    }`}
                  >
                    <input
                      type='radio'
                      name='tripType'
                      value='Domestic'
                      checked={tripType === 'Domestic'}
                      onChange={handleChangeTripType}
                      className='radio-input'
                    />
                    <span className='custom-radio'></span>
                    Domestic
                  </label>

                  <label
                    className={`radio-label ${
                      tripType === 'International' ? 'selected' : ''
                    }`}
                  >
                    <input
                      type='radio'
                      name='tripType'
                      value='International'
                      checked={tripType === 'International'}
                      onChange={handleChangeTripType}
                      className='radio-input'
                    />
                    <span className='custom-radio'></span>
                    International
                  </label>
                </div>

                <div className='row'>
                  <div className='col-lg-4 col-md-12 col-sm-12'>
                    <div className='search-input-box flight-from'>
                      <label className='form-label'>City</label>
                      <SearchDropdown
                        formData={formData}
                        data={City.getAllCities()}
                        value={formData.city}
                        placeholder=''
                        onSelect={handleCitySelect}
                      />
                      {/* <input
                        className='autocomplete-airport inp-text '
                        id='search-user'
                        type='text'
                        name='city'
                        autoComplete='off'
                        onChange={handleChange}
                        value={formData.city}
                        required
                      /> */}
                    </div>
                  </div>
                  <div className='col-lg-8 col-md-12 col-sm-12'>
                    <div className='form-group'>
                      <div className='subContent'>
                        <div className='search-input-box departure'>
                          <div
                            onClick={() => setDateRangeOpen(true)}
                            style={{
                              position: 'absolute',
                              left: '0px',
                              right: '0px',
                              width: '100%',
                              height: '100%'
                            }}
                          ></div>
                          <label
                            onClick={() => setDateRangeOpen(true)}
                            className='form-label'
                          >
                            Check-In
                          </label>
                          <input
                            onClick={() => setDateRangeOpen(true)}
                            className='autocomplete-airport inp-text'
                            type='text'
                            name='departure_date'
                            value={
                              formData.departureDate
                                ? moment(formData.departureDate).format(
                                    'DD MMM YYYY'
                                  )
                                : formData.departureDate
                            }
                            placeholder=''
                            required
                          />
                          <p>
                            <span>
                              {formData.departureDate
                                ? moment(formData.departureDate).format('dddd')
                                : ''}
                            </span>
                          </p>
                          <DateRangeSelector
                            dateRangeOpen={dateRangeOpen}
                            setDateRangeOpen={setDateRangeOpen}
                            handleOnchangeDate={handleOnchangeDate}
                          />
                        </div>
                        <div className='search-input-box departure'>
                          <div
                            onClick={() => setDateEndOpen(true)}
                            style={{
                              position: 'absolute',
                              left: '0px',
                              right: '0px',
                              width: '100%',
                              height: '100%'
                            }}
                          ></div>
                          <label
                            className='form-label'
                            onClick={() => setDateEndOpen(true)}
                          >
                            Check-Out
                          </label>
                          <input
                            onClick={() => setDateEndOpen(true)}
                            className='autocomplete-airport inp-text'
                            type='text'
                            name='departure_date'
                            value={
                              formData.returnDate
                                ? moment(formData.returnDate).format(
                                    'DD MMM YYYY'
                                  )
                                : formData.returnDate
                            }
                            placeholder=''
                            required
                          />
                          <p>
                            <span>
                              {formData.returnDate
                                ? moment(formData.returnDate).format('dddd')
                                : ''}
                            </span>
                          </p>
                          <EndDateSelector
                            formData={formData}
                            dateRangeOpen={endOpen}
                            setDateRangeOpen={setDateEndOpen}
                            handleOnchangeDate={handleOnchangeEndOpen}
                          />
                        </div>
                        <div className='search-input-box room-box'>
                          <div
                            onClick={() => setGuestCounterOpen(true)}
                            style={{
                              position: 'absolute',
                              left: '0px',
                              right: '0px',
                              width: '100%',
                              height: '100%'
                            }}
                          ></div>
                          <label
                            onClick={() => setGuestCounterOpen(true)}
                            className='form-label'
                          >
                            Guests
                          </label>
                          <input
                            onClick={() => setGuestCounterOpen(true)}
                            className='autocomplete-airport inp-text'
                            type='text'
                            name='departure_date'
                            value={totalTravelers === 0 ? '' : totalTravelers}
                            placeholder=''
                            required
                          />
                          <RoomsGuests
                            setGuestCounterOpen={setGuestCounterOpen}
                            guestCounterOpen={guestCounterOpen}
                            formData={formData}
                            setFormData={setFormData}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col-lg-7 col-md-12 col-12 enquiry-form'>
                    <div className='row'>
                      <div className='col-md-4  m-b-10'>
                        <div className='form-group'>
                          <input
                            type='text'
                            className='form-control'
                            name='full_name'
                            placeholder='Full Name'
                            value={formData.full_name}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>
                      <div className='col-md-4  m-b-10'>
                        <div className='form-group'>
                          <input
                            type='text'
                            className='form-control'
                            name='contact'
                            placeholder='Mobile Number'
                            pattern='^\d*$'
                            value={formData.contact}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>
                      <div className='col-md-4'>
                        <div className='form-group'>
                          <input
                            type='text'
                            className='form-control'
                            name='email'
                            placeholder='Email ID'
                            value={formData.email}
                            onChange={handleChange}
                            required
                          />
                          <input
                            type='hidden'
                            name='product_type'
                            value='hotels'
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-lg-6 col-md-12 col-12'>
                      <div className='quota-box'>
                        <div className='q-label'>
                          <p>Property Type:</p>
                        </div>
                        <div className='radio-group'>
                          <label
                            className={`radio-label ${
                              selectedFare === '3 Star' ? 'selected' : ''
                            }`}
                          >
                            <input
                              type='radio'
                              name='Regular'
                              value='3 Star'
                              checked={selectedFare === '3 Star'}
                              onChange={e => setSelectedFare(e.target.value)}
                              className='radio-input'
                            />
                            <span className='custom-radio'></span>3 Star
                          </label>

                          <label
                            className={`radio-label ${
                              selectedFare === '4 Star' ? 'selected' : ''
                            }`}
                          >
                            <input
                              type='radio'
                              name='Student'
                              value='4 Star'
                              checked={selectedFare === '4 Star'}
                              onChange={e => setSelectedFare(e.target.value)}
                              className='radio-input'
                            />
                            <span className='custom-radio'></span>4 Star
                          </label>
                          <label
                            className={`radio-label ${
                              selectedFare === '5 Star' ? 'selected' : ''
                            }`}
                          >
                            <input
                              type='radio'
                              name='Student'
                              value='5 Star'
                              checked={selectedFare === '5 Star'}
                              onChange={e => setSelectedFare(e.target.value)}
                              className='radio-input'
                            />
                            <span className='custom-radio'></span>5 Star
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className='col-lg-6 col-md-12 col-12'>
                      <div className='recent-box'>
                        <div id='date'></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='button-center'>
                  <button type='submit' className='btn search-btn'>
                    <span className='button-text'>ENQUIRE NOW</span>
                  </button>
                </div>
              </form>
              {success && (
                <div className='success-popup'>Thank you for your enquiry!</div>
              )}
            </div>
          </div>
        </div>
        {/* <h2 className='text-white'>{sliderImages[0]?.title}</h2> */}
        <SliderImages data={sliderImages[0]?.displayImages || []} />
      </div>
    </div>
  )
}
export default Hotels
